// @ts-nocheck // Ignore this line, because the file is not a TypeScript file

import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
	server: {
		NODE_ENV: z.enum(["development", "production", "test"]),
		VERCEL_ENV: z.enum(["development", "preview", "production"]).default("development"),
	},
	client: {
		NEXT_PUBLIC_LOCALE: z.string().default("nl-nl"),
		NEXT_PUBLIC_API_URL: z.string().url().optional(),
		NEXT_PUBLIC_PIMCORE_API_URL: z.string().url(),
	},
	runtimeEnv: {
		NODE_ENV: process.env.NODE_ENV,
		VERCEL_ENV: process.env.VERCEL_ENV,
		NEXT_PUBLIC_LOCALE: process.env.NEXT_PUBLIC_LOCALE,
		NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
		NEXT_PUBLIC_PIMCORE_API_URL: process.env.NEXT_PUBLIC_PIMCORE_API_URL,
	},
});
